import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import { Row } from '../Scaffold';
import RegisterModal from './RegisterModal';
import StatisticsModal from './StatisticsModal';
import Filter from './Filter';
import DataMap from '../Map';


class AllResults extends React.PureComponent {
  state = {
    selectedTab: 'tab1',
    showFilterSlide: false,
    showRegisterPopup: false,
    showStatisticsPopup: false,
    statisticsData: {},
    filterGender: null,
  };

  handleTabChange = (e) => {
    switch (e.target.value) {
      case 'tab1':
        this.setState({ selectedTab: e.target.value });
        if (this.state.showFilterSlide) { this.toggleSlideFilter(); }
        break;
      case 'tab2':
        this.toggleRegisterModal();
        break;
      default:
        break;
    }
  };

  toggleSlideFilter = () => {
    this.setState({ showFilterSlide: !this.state.showFilterSlide });
  }

  toggleRegisterModal = () => {
    this.setState({ showRegisterPopup: !this.state.showRegisterPopup });
  }

  toggleStatisticsModal = (data) => {
    this.setState({ showStatisticsPopup: !this.state.showStatisticsPopup, statisticsData: data });
  }

  goToRegistration = () => {
    const {
      activity, weight, height, units, smokingamount, gender,
    } = this.props;

    const personalData = {
      activity, weight, height, units, smokingamount, gender, linkBack: false,
    };

    localStorage.setItem('personalInfo', JSON.stringify(personalData));
    window.location = '/register';
  }

  showMapTab = () => {
    this.setState({ selectedTab: 'tab2' });
    this.toggleRegisterModal();
  }

  calcBMIPos = () => {
    const { weight, height } = this.props;
    let bmi = (parseFloat(weight) / ((parseFloat(height) / 100) * (parseFloat(height) / 100))).toFixed(2);
    let posPercent = 0;
    bmi = Math.round(bmi);

    switch (true) {
      case bmi <= 15:
        posPercent = 0.09;
        break;
      case bmi === 16:
        posPercent = 0.18;
        break;
      case bmi === 17:
        posPercent = 0.241;
        break;
      case bmi >= 18 && bmi <= 25:
        posPercent = (0.702 - 0.272) / 7 * (bmi - 18) + 0.272;
        break;
      case bmi === 26:
        posPercent = 0.7318;
        break;
      case bmi === 27:
        posPercent = 0.7916;
        break;
      case bmi === 28:
        posPercent = 0.851;
        break;
      case bmi === 29:
        posPercent = 0.9106;
        break;
      case bmi >= 30:
        posPercent = 0.9702;
        break;
      default:
        break;
    }

    return posPercent;
  }

  calcAlcoholPos = () => {
    const { units } = this.props;
    const unitsNum = parseInt(units, 10);
    let posPercent = 0;

    switch (true) {
      case unitsNum === 0:
        posPercent = 0;
        break;
      case unitsNum >= 1 && unitsNum <= 5:
        posPercent = 0.192;
        break;
      case unitsNum >= 15 && unitsNum <= 30:
        posPercent = 0.225;
        break;
      case unitsNum >= 30 && unitsNum <= 100:
        posPercent = 0.3;
        break;
      case unitsNum >= 100:
        posPercent = 0.625;
        break;
      default:
        break;
    }

    return posPercent;
  }

  resultScore = () => {
    const {
      smokingamount, weight, height, activity, units,
    } = this.props;

    let score = 0;

    if (parseInt(smokingamount, 10) === 0) {
      score += 10;
    }

    switch (parseInt(units, 10)) {
      case 0:
        score += 10;
        break;
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        score += 8;
        break;
      case 6:
      case 7:
      case 8:
      case 9:
        score += 5;
        break;
      case 10:
      case 11:
      case 12:
      case 13:
      case 14:
        score += 4;
        break;
      default:
        break;
    }

    switch (parseInt(activity, 10)) {
      case 7:
        score += 10;
        break;
      case 6:
        score += 8;
        break;
      case 5:
        score += 6;
        break;
      case 4:
        score += 4;
        break;
      case 3:
        score += 3;
        break;
      case 2:
        score += 2;
        break;
      case 1:
        score += 1;
        break;
      default:
        break;
    }

    const bmi = (parseFloat(weight) / ((parseFloat(height) / 100) * (parseFloat(height) / 100))).toFixed(2);

    if (bmi <= 15) {
      score += 3;
    } else if (bmi <= 16) {
      score += 5;
    } else if (bmi <= 17) {
      score += 8;
    } else if (bmi <= 18) {
      score += 9;
    } else if (bmi <= 22) {
      score += 10;
    } else if (bmi <= 23) {
      score += 8;
    } else if (bmi <= 24) {
      score += 7;
    } else if (bmi <= 25) {
      score += 6;
    } else if (bmi <= 26) {
      score += 5;
    } else if (bmi <= 27) {
      score += 4;
    } else if (bmi <= 28) {
      score += 3;
    } else if (bmi <= 29) {
      score += 2;
    } else if (bmi > 29) {
      score += 1;
    }

    return score;
  }

  render() {
    const {
      smokingamount, weight, height, activity, units, resetFunc,
    } = this.props;

    const score = this.resultScore();
    const percent = score / 40 * 100;

    const overallStatement = [];

    if (score < 11) {
      overallStatement.push("You've got a way to go!");
    } else if (score < 20) {
      overallStatement.push("Overall, You're doing OK!");
    } else if (score < 30) {
      overallStatement.push("Overall, You're doing just fine!");
    } else {
      overallStatement.push("Overall, You're doing great!");
    }


    if (smokingamount > 0) {
      overallStatement.push('You really need to quit smoking. We can help!');
    } else if (units > 14) {
      overallStatement.push('You really need to drink less. We can help!');
    } else if ((parseFloat(weight) / ((parseFloat(height) / 100) * (parseFloat(height) / 100))) > 31) {
      overallStatement.push('You could do with losing some weight. We can help!');
    } else if (activity < 3) {
      overallStatement.push('Getting more active will do wonders for your health');
    }

    const bmi = (parseFloat(weight) / ((parseFloat(height) / 100) * (parseFloat(height) / 100))).toFixed(2);

    const str = "I've taken @lwdorset's Healthy You quiz - here are my results! How healthy are you?";
    const fbLink = `https://www.facebook.com/share.php?u=https%3A%2F%2Fwww.livewelldorset.co.uk%2Fare-you-living-well%2F%3Fscore%3D${score}`;
    const twLink = `https://twitter.com/intent/tweet?text=${encodeURI(str)}&url=https%3A%2F%2Fwww.livewelldorset.co.uk%2Fare-you-living-well%2F%3Fscore%3D${score}`;

    return ([
      <Row key={0} classes="all-results" setRef={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <div className="tab-container">
          <input className="tab-checkbox" id="tab1" type="radio" name="tabs" value="tab1" onChange={(e) => { this.handleTabChange(e); }} checked={this.state.selectedTab === 'tab1'} />
          <input className="tab-checkbox" id="tab2" type="radio" name="tabs" value="tab2" onChange={(e) => { this.handleTabChange(e); }} checked={this.state.selectedTab === 'tab2'} />
          <div className="contents">
            <div className="item">
              <label className="tab tab1" htmlFor="tab1"><Paragraph classes="tab-title" center>My Results</Paragraph></label>

              <div className="content tab1-content" ref={(tab1Content) => { this.tab1Content = tab1Content; }}>
                <Paragraph classes="tab-image" center><img src="/site/images/flower.svg" alt="flower" /></Paragraph>
                <Paragraph classes="content-title" center>My Results</Paragraph>
                <div className="dial-container">
                  <span className="dial-text red">Unhealthy</span>
                  <div className="dial">
                    <div className="dial-circle" style={{ backgroundImage: 'url(/site/images/campaign/dial.png)' }} />
                    {/* 75 is the percentage number */}
                    <div className="dial-needle" style={{ backgroundImage: 'url(/site/images/campaign/dial-needle.svg)', transform: `translateX(-50%) rotate(${percent / 100 * 288 + 36}deg)` }} />
                  </div>
                  <span className="dial-text green">Healthy</span>
                </div>
                <div className="results">
                  <Paragraph classes="section-text" center>{ overallStatement.join(' ') }</Paragraph>

                  <div className="result-item blue">
                    <div className="result-border">
                      <Paragraph classes="border-image" center>
                        <img src="/site/images/campaign/activity-icon.svg" alt="activity" width="20" height="20" />
                      </Paragraph>
                      <Paragraph classes="section-text" center>Activity per week</Paragraph>
                      <div className="resultbar-container">
                        <div className="snap-text" style={{ marginLeft: `calc(100% * ${activity} / 7)`, transform: 'translateX(-50%)' }}>{activity}</div>
                        <div className="resultbar brokenlines"><div className="brokenlines-inside" /></div>
                        <Paragraph classes="national-text" center>National guidelines: <strong>30 minutes of activity, 5 days per week</strong></Paragraph>
                      </div>
                    </div>
                  </div>
                  <div className="result-item purple">
                    <div className="result-border">
                      <Paragraph classes="border-image" center>
                        <img src="/site/images/campaign/wh-icon.svg" alt="" width="20" height="20" />
                      </Paragraph>
                      <Paragraph classes="section-text" center>Weight</Paragraph>
                      <div className="resultbar-container">
                        <div
                          className="snap-text"
                          style={{
                            transform: 'translateX(-50%)',
                            marginLeft: `calc(100% * ${this.calcBMIPos()})`,
                          }}
                        >
                          {bmi} BMI
                        </div>
                        <div className="resultbar" />
                        <Paragraph classes="national-text" center>National guidelines: <strong>18 - 25 BMI</strong></Paragraph>
                      </div>
                    </div>
                  </div>
                  <div className="result-item red">
                    <div className="result-border">
                      <Paragraph classes="border-image" center>
                        <img src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="" width="20" height="20" />
                      </Paragraph>
                      <Paragraph classes="section-text" center>Smoking</Paragraph>
                      <div className="resultbar-container">
                        <div
                          className={`snap-text ${parseInt(smokingamount, 10) > 0 ? '' : 'green'}`}
                          style={{
                            transform: parseInt(smokingamount, 10) > 0 ? 'translateX(0)' : 'translateX(-100%)',
                            marginLeft: parseInt(smokingamount, 10) > 0 ? 0 : '100%',
                          }}
                        >
                          {parseInt(smokingamount, 10) > 0 ? 'Yes' : 'No'}
                        </div>
                        <div className="resultbar" />
                        <Paragraph classes="national-text" center>National guidelines: <strong>No smoking</strong></Paragraph>
                      </div>
                    </div>
                  </div>
                  <div className="result-item yellow">
                    <div className="result-border">
                      <Paragraph classes="border-image" center>
                        <img src="/site/images/campaign/drinking-icon.svg" alt="" width="20" height="20" />
                      </Paragraph>
                      <Paragraph classes="section-text" center>Drinking per week</Paragraph>
                      <div className="resultbar-container">
                        <div
                          className="snap-text"
                          style={{
                            transform: 'translateX(-50%)',
                            marginLeft: `calc(100% * ${this.calcAlcoholPos()})`,
                          }}
                        >
                          {units}
                        </div>
                        <div className="resultbar" />
                        <Paragraph classes="national-text" center>National guidelines: <strong>0 - 14 units</strong></Paragraph>
                      </div>
                    </div>
                  </div>

                  <div className="share">
                    <Paragraph classes="desc-text" center>Share your results with your friends</Paragraph>
                    <div className="social-icons">
                      <a href={twLink} target="_blank"><img src="/site/images/campaign/twitter.svg" alt="twitter" /></a>
                      <a href={fbLink} target="_blank"><img src="/site/images/campaign/facebook.svg" alt="facebook" /></a>
                    </div>
                  </div>

                  <div className="linkBack">
                    <Paragraph classes="desc-text" center>Want to try again?</Paragraph>
                    <Button classes={['underline-button']} label="Restart the quiz" onClick={resetFunc} />
                  </div>
                </div>
              </div>
            </div>

            <div className="item">
              <label className="tab tab2" htmlFor="tab2"><Paragraph classes="tab-title" center>LiveWell Dorset</Paragraph></label>

              <div className="content tab2-content" ref={(tab2Content) => { this.tab2Content = tab2Content; }}>
                <div className="map-outer">
                  <div className="gmap-canvas">
                    {this.state.selectedTab === 'tab2' ? <DataMap openStatisticsModal={this.toggleStatisticsModal} /> : null }
                  </div>
                </div>
                <div className="highlight-info">
                  <div className="highlightbar" />
                  <div className="text-group">
                    <Paragraph classes="bar-text red">Unhealthy</Paragraph>
                    <Paragraph classes="bar-text green">Healthy</Paragraph>
                  </div>
                </div>
                <button className="filterBtn" onClick={this.toggleSlideFilter} />
              </div>
            </div>
          </div>
        </div>
        <div className="footer-register">
          <Paragraph classes="footer-text">Access FREE, personalised advice and coaching.</Paragraph>
          <Button classes={['color-button']} label="Register now" onClick={this.goToRegistration} />
        </div>
      </Row>,
      <Filter key={1} closeSlide={this.toggleSlideFilter} classes={this.state.showFilterSlide && 'is-visible'} updateGender={gender => this.setState({ filterGender: gender })} />,
      <RegisterModal goToRegistration={this.goToRegistration} key={2} closePopup={this.toggleRegisterModal} classes={this.state.showRegisterPopup && 'is-visible'} showMap={this.showMapTab} />,
      <StatisticsModal key={3} data={this.state.statisticsData} closePopup={this.toggleStatisticsModal} percent={percent} classes={this.state.showStatisticsPopup && 'is-visible'} gender={this.state.filterGender} />,
    ]);
  }
}

AllResults.propTypes = {
  // handleSubmit: PropTypes.func.isRequired,
  smokingamount: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  weight: PropTypes.number.isRequired,
  activity: PropTypes.number.isRequired,
  // score: PropTypes.number.isRequired,
  // pregnant: PropTypes.string.isRequired,
  // dashboard: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'campaign',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AllResults);



// WEBPACK FOOTER //
// ./src/Components/Campaign/FormPages/AllResults.jsx